var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"swiper",staticClass:"swiper-container",style:({ '--width': _vm.width, '--time': _vm.time / 1000 + 's' })},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.bannerList),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide"},[_c('img',{attrs:{"src":item.src,"title":item.title}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }